export const SET_MENU_CLICKED_CONTROL_MODAL_DATA =
  "SET_MENU_CLICKED_CONTROL_MODAL_DATA";
export const SET_CATALOG_MODAL_DELETE_ROW_ID =
  "SET_CATALOG_MODAL_DELETE_ROW_ID";
